import { EMessageSpeaker } from '~/models/features'

export enum ESocialLinks {
  facebook = 'facebook.com',
  instagram = 'instagram.com',
  linkedin = 'linkedin.com',
  twitter = 'twitter.com',
  yoututbe = 'youtube.com',
  github = 'github.com',
  pinterest = 'pinterest.com',
  reddit = 'reddit.com',
  snapchart = 'snapchat.com',
  tiktok = 'tiktok.com',
  whatsapp = 'whatsapp.com',
  zoom = 'zoom.com',
}

export type TChat = {
  aiResponse: string
  conversationId: string
  activateCalendly: boolean
}

export type TChatMessage = {
  speaker: EMessageSpeaker
  message: string
}
